<div class="project-form-page">

  <!-- Loading -->
  <div class="loading-center" *ngIf="loading()">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading project…</p>
  </div>

  <ng-container *ngIf="!loading()">

    <!-- Header -->
    <div class="page-header">
      <div class="header-left">
        <button mat-icon-button (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">{{ pageTitle }}</h1>
      </div>
    </div>

    <!-- Error -->
    <div class="error-banner" *ngIf="error()">
      <mat-icon>error_outline</mat-icon>
      <span>{{ error() }}</span>
      <button mat-icon-button (click)="error.set(null)"><mat-icon>close</mat-icon></button>
    </div>

    <div class="form-grid">

      <!-- Basic Info -->
      <mat-card class="form-card">
        <mat-card-header>
          <mat-card-title>Basic Information</mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div class="field-row" *ngIf="!isEdit && templates().length > 0">
            <mat-form-field appearance="outline" class="field-full">
              <mat-label>Create from template (optional)</mat-label>
              <mat-select [(ngModel)]="selectedTemplateId">
                <mat-option value="">— Blank project —</mat-option>
                <mat-option *ngFor="let t of templates()" [value]="t.id">
                  {{ t.name }}<span *ngIf="t.code"> ({{ t.code }})</span>
                </mat-option>
              </mat-select>
              <mat-hint>Copies members, components, labels, boards, and custom fields from the template</mat-hint>
            </mat-form-field>
          </div>

          <div class="field-row">
            <mat-form-field appearance="outline" class="field-full">
              <mat-label>Project Name *</mat-label>
              <input matInput [(ngModel)]="name" placeholder="e.g. Customer Portal" maxlength="200" />
              <mat-hint align="end">{{ name.length }}/200</mat-hint>
            </mat-form-field>
          </div>

          <div class="field-row two-col">
            <mat-form-field appearance="outline">
              <mat-label>Project Code</mat-label>
              <input matInput [(ngModel)]="code" placeholder="AUTO" maxlength="50"
                style="text-transform: uppercase" />
              <mat-hint>Auto-generated if empty; must be unique</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Issue Key Prefix *</mat-label>
              <input matInput [(ngModel)]="issueKeyPrefix" placeholder="PROJ" maxlength="20"
                style="text-transform: uppercase" required />
              <mat-hint>Used for issue keys (e.g. PROJ-1)</mat-hint>
            </mat-form-field>
          </div>

          <div class="field-row two-col">
            <mat-form-field appearance="outline">
              <mat-label>Category *</mat-label>
              <mat-select [(ngModel)]="category" required>
                <mat-option value="">— Select —</mat-option>
                <mat-option *ngFor="let c of categories" [value]="c">{{ c }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Color</mat-label>
              <input matInput type="color" [(ngModel)]="color" />
              <mat-hint>Project color label</mat-hint>
            </mat-form-field>
          </div>

          <div class="field-row">
            <mat-form-field appearance="outline" class="field-full">
              <mat-label>Description</mat-label>
              <textarea matInput [(ngModel)]="description" rows="3" maxlength="4000"
                placeholder="Describe the project goals…"></textarea>
              <mat-hint align="end">{{ description.length }}/4000</mat-hint>
            </mat-form-field>
          </div>

        </mat-card-content>
      </mat-card>

      <!-- Settings -->
      <mat-card class="form-card">
        <mat-card-header>
          <mat-card-title>Settings</mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div class="field-row two-col">
            <mat-form-field appearance="outline" *ngIf="isEdit">
              <mat-label>Status</mat-label>
              <mat-select [(ngModel)]="status">
                <mat-option *ngFor="let s of statusOptions" [value]="s.value">{{ s.label }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Priority</mat-label>
              <mat-select [(ngModel)]="priority">
                <mat-option *ngFor="let p of priorityOptions" [value]="p.value">{{ p.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="field-row two-col">
            <mat-form-field appearance="outline">
              <mat-label>Account</mat-label>
              <mat-select [(ngModel)]="accountId">
                <mat-option value="">— None —</mat-option>
                <mat-option *ngFor="let a of accounts()" [value]="a.id">{{ a.name }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Department</mat-label>
              <mat-select [(ngModel)]="departmentId">
                <mat-option value="">— None —</mat-option>
                <mat-option *ngFor="let d of departments()" [value]="d.id">{{ d.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="field-row">
            <mat-form-field appearance="outline" class="field-full">
              <mat-label>Project Owner *</mat-label>
              <mat-select [(ngModel)]="ownerId" required>
                <mat-option value="">— Select owner —</mat-option>
                <mat-option *ngFor="let e of employees()" [value]="e.id">{{ e.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="field-row two-col">
            <mat-form-field appearance="outline">
              <mat-label>Budget</mat-label>
              <span matPrefix>$ </span>
              <input matInput type="number" [(ngModel)]="budget" placeholder="0.00" min="0" />
            </mat-form-field>

            <div class="checkbox-group" *ngIf="isEdit">
              <mat-checkbox [(ngModel)]="isActive">Active Project</mat-checkbox>
            </div>
          </div>

          <!-- Progress (edit only) -->
          <div class="field-row" *ngIf="isEdit">
            <mat-form-field appearance="outline" class="field-full">
              <mat-label>Progress (%)</mat-label>
              <input matInput type="number" [(ngModel)]="progress" min="0" max="100" />
              <mat-hint>0 – 100</mat-hint>
            </mat-form-field>
          </div>

        </mat-card-content>
      </mat-card>

      <!-- Dates -->
      <mat-card class="form-card">
        <mat-card-header>
          <mat-card-title>Timeline</mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div class="field-row three-col">
            <mat-form-field appearance="outline">
              <mat-label>Start Date</mat-label>
              <input matInput type="date" [(ngModel)]="startDate" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>End Date</mat-label>
              <input matInput type="date" [(ngModel)]="endDate" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Due Date</mat-label>
              <input matInput type="date" [(ngModel)]="dueDate" />
            </mat-form-field>
          </div>

        </mat-card-content>
      </mat-card>

      <!-- Published App -->
      <mat-card class="form-card">
        <mat-card-header>
          <mat-card-title>
            <mat-checkbox [(ngModel)]="isPublishedApp" style="margin-right: 8px"></mat-checkbox>
            Published App
          </mat-card-title>
        </mat-card-header>
        <mat-card-content *ngIf="isPublishedApp">

          <div class="field-row two-col">
            <mat-form-field appearance="outline">
              <mat-label>Platform</mat-label>
              <mat-select [(ngModel)]="platform">
                <mat-option value="">— Select —</mat-option>
                <mat-option *ngFor="let p of platforms" [value]="p">{{ p }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Package Name</mat-label>
              <input matInput [(ngModel)]="packageName" placeholder="com.example.app" maxlength="200" />
            </mat-form-field>
          </div>

          <div class="field-row">
            <mat-form-field appearance="outline" class="field-full">
              <mat-label>Store URL</mat-label>
              <mat-icon matPrefix>link</mat-icon>
              <input matInput [(ngModel)]="storeUrl" placeholder="https://play.google.com/..." maxlength="500" />
            </mat-form-field>
          </div>

        </mat-card-content>
      </mat-card>

    </div>

    <!-- Actions -->
    <div class="form-actions">
      <button mat-stroked-button (click)="goBack()" [disabled]="saving()">
        Cancel
      </button>
      <button mat-raised-button color="primary" (click)="save()"
        [disabled]="saving() || !name.trim() || !ownerId || !category || !issueKeyPrefix.trim()">
        <mat-spinner diameter="18" *ngIf="saving()"></mat-spinner>
        <mat-icon *ngIf="!saving()">save</mat-icon>
        {{ saving() ? 'Saving…' : (isEdit ? 'Update Project' : 'Create Project') }}
      </button>
    </div>

  </ng-container>

</div>
